import type { CalendarData, TagsRequest } from '@/models/interface/calendar';
import type { AycePlanUsageLogSummaryResponse } from '@/models/interface/reports';
import type { ValidateLivestreamJoinResponse } from '@/models/interface/streaming';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class MemberRecordService extends ApiFactory {
  constructor() {
    super('MemberRecord');
  }

    /**
   * 查詢行事曆各種事項
   * @param params
   * @returns
   */
    queryCalendar(params: {
      startTimestamp: number;
      endTimestamp: number;
    }): Promise<ApiDataResponse<CalendarData[]>> {
      const serializedParams = new URLSearchParams({
        startTimestamp: params.startTimestamp.toString(),
        endTimestamp: params.endTimestamp.toString()
      });
  
      return this.get(`QueryCalendarNew?${serializedParams}`);
    }

  /**
   * 修改 Tag 狀態
   * @param data
   * @returns
   */
  updateCalendarTags(data: TagsRequest): Promise<ApiDataResponse<boolean>> {
    return this.post(`UpdateCalendarTags`, data);
  }

  /**
   * 取得已使用點數及總點數
   * @returns
   */
  getTotalAndUsed(): Promise<
    ApiDataResponse<{
      total: number;
      used: number;
    }>
  > {
    return this.get(`GetTotalAndUsed`);
  }

  /**
   * 驗證是否可以加入直播室
   * @param sourceId - 直播頻道 ID
   */
  validateLivestreamJoin(
    sourceId: string
  ): Promise<ApiDataResponse<ValidateLivestreamJoinResponse>> {
    return super.get('ValidateLivestreamJoin', { sourceId });
  }

  /**
   * 取得 定期制方案課程紀錄摘要
   */
  getAycePlanUsageLogSummary(): Promise<ApiDataResponse<AycePlanUsageLogSummaryResponse>> {
    return super.get('PlanUsageLogSummary');
  }
}
